      $(document).ready(function() {
  // Function to get URL parameter by name
  function getParameterByName(name) {
    var url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  // Function to update the variant selection based on URL parameter
  function updateVariantFromUrl() {
    var variantId = getParameterByName('variant');
    if (variantId) {
      var variantSelect = document.getElementById('variant-select');
      if (variantSelect) {
        for (var i = 0; i < variantSelect.options.length; i++) {
          if (variantSelect.options[i].value == variantId) {
            variantSelect.selectedIndex = i;
            // Trigger change event to update the price and discount
            var event = new Event('change');
            variantSelect.dispatchEvent(event);
            break;
          }
        }
      }
    }
  }

  // Function to update the discount badge based on selected variant
  function updateDiscountBadge() {
    // Get the selected variant ID
    var selectedVariantId = $('#variant-select').val();
    
    // Hide all discount badges
    $('.dbtfy-discount-saved__item').attr('hidden', true);
    
    // Show the discount badge for the selected variant
    $('.dbtfy-discount-saved__item[data-variant-id="' + selectedVariantId + '"]').removeAttr('hidden');
  }

  // Initial discount badge display
  updateDiscountBadge();
  updateVariantFromUrl();

  // Update discount badge on variant change
  $('#variant-select').change(function() {
    updateDiscountBadge();
  });
});
